module.exports = __webpack_public_path__ + "static/img/banner-csr-11.3fa9b42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-csr-11.jpg
// module id = 5f2X
// module chunks = 98